import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './share_campaign_compact.less'
import { getI18n } from 'client/i18n'
import CopyBox from 'components/common/copy_box'
import 'node_modules/@paypalcorp/pp-vx/dist/components/icons/icons.css'
import {
  EmailSharing,
  TwitterSharing,
  FacebookSharing,
  MessengerSharing,
  WhatsAppSharing,
  SmsSharing,
} from 'components/common/share_buttons'

const i18n = getI18n('components/share_campaign_compact')

class ShareCampaignCompact extends React.Component {
  static propTypes = {
    shareUrl: PropTypes.string.isRequired,
    displayUrl: PropTypes.string.isRequired,
    shareable: PropTypes.bool.isRequired,
    appId: PropTypes.number.isRequired,

    onClickOverride: PropTypes.func,

    showFacebook: PropTypes.bool,
    showMessenger: PropTypes.bool,
    showTwitter: PropTypes.bool,
    showWhatsApp: PropTypes.bool,
    showEmail: PropTypes.bool,
    showSms: PropTypes.bool,
    showSubtext: PropTypes.bool,
    emailBody: PropTypes.string,
    emailSubject: PropTypes.string,
    isMobile: PropTypes.bool,
    charity: PropTypes.object,
  }

  static defaultProps = {
    shareable: true,
    showFacebook: true,
    showMessenger: true,
    showTwitter: true,
    showWhatsApp: true,
    showEmail: true,
    showSms: true,
    showSubtext: false,
    isMobile: false,
  }

  render() {
    let shareText = this.props.displayUrl
    if (!this.props.shareable) {
      shareText = i18n('link_placeholder')
    }

    return (
      <div>
        <div styleName="share-icons">
          <div styleName="row">
            <EmailSharing {...this.props} className={styles['share-icon']} />

            <MessengerSharing
              {...this.props}
              className={styles['share-icon']}
            />

            {this.props.isMobile && (
              <SmsSharing {...this.props} className={styles['share-icon']} />
            )}

            <FacebookSharing {...this.props} className={styles['share-icon']} />

            <TwitterSharing {...this.props} className={styles['share-icon']} />

            <WhatsAppSharing {...this.props} className={styles['share-icon']} />
          </div>
        </div>
        <CopyBox
          text={shareText}
          copyText={this.props.shareUrl}
          enabled={this.props.shareable}
          charity={this.props.charity}
        />
      </div>
    )
  }
}

export default cssModules(ShareCampaignCompact, styles)
